/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';
import { ticketColors } from '../theme/public-api';
import { VueltiDurmiendo } from '../ui/VueltiDurmiendo';
import { modalExperience } from './modalExperience.styles';

type Props = {
  loading?: boolean;
  empty?: boolean;
  emptyTitle?: string;
  emptyMessage?: string;
  loadingMessage?: string;
};

export function ModalStatePanel({
  loading = false,
  empty = false,
  emptyTitle = 'Sin resultados',
  emptyMessage = 'Probá otros filtros o un rango de fechas distinto.',
  loadingMessage = 'Cargando…',
}: Props) {
  if (loading) {
    return (
      <View style={modalExperience.stateBox}>
        <ActivityIndicator color={ticketColors.gold} />
        <Text style={modalExperience.stateText}>{loadingMessage}</Text>
      </View>
    );
  }

  if (empty) {
    return (
      <View style={modalExperience.stateBox}>
        <VueltiDurmiendo size={80} />
        <Text style={modalExperience.stateTitle}>{emptyTitle}</Text>
        <Text style={modalExperience.stateText}>{emptyMessage}</Text>
      </View>
    );
  }

  return null;
}
